const A = {
  "charleston-sc": {
    intro: [
      "Charleston is a city of narrow historic streets, waterfront porches and homes that have seen centuries come and go, and all of that character comes with a whole lot of stuff to clear out. Skedaddle handles junk removal across the peninsula and beyond, working carefully in tight downtown driveways and grand old single houses alike.",
      "Whether you are cleaning out an attic South of Broad, turning over a rental near the College, or clearing storm debris after a Lowcountry blow, we haul it fast and leave your place tidy. One call and it skedaddles!",
    ],
    neighborhoods: [
      ["Downtown Peninsula", "cobblestone lanes and historic single houses"],
      ["South of Broad", "grand antebellum homes near the Battery"],
      ["Harleston Village", "tucked behind the College of Charleston"],
      ["Radcliffeborough", "classic porches along Rutledge Avenue"],
      ["Cannonborough Elliotborough", "colorful cottages and corner cafes"],
      ["Wagener Terrace", "leafy streets near Hampton Park"],
      ["Hampton Park Terrace", "bungalows around the park loop"],
      ["The Crescent", "stately homes off the Ashley River"],
      ["Byrnes Downs", "tidy 1940s cottages in West Ashley reach"],
      ["Wraggborough", "historic blocks near the Museum"],
      ["Ansonborough", "brick townhomes near the waterfront"],
      ["French Quarter", "galleries and old warehouses"],
      ["Eastside", "close knit streets near the harbor"],
      ["North Central", "revived homes along the upper peninsula"],
      ["West Side", "near the medical district"],
      ["Cainhoy area", "growing edges toward Clements Ferry"],
    ],
  },
  "north-charleston-sc": {
    intro: [
      "North Charleston is big, busy and always building, from the shops at Tanger Outlets to the neighborhoods around the old Navy base. With that much activity comes plenty of junk to clear, and Skedaddle is right there to haul it away.",
      "We handle everything from apartment turnovers off Rivers Avenue to garage cleanouts in Park Circle and warehouse clear outs near the industrial corridor. Fast, friendly and upfront across all of North Charleston.",
    ],
    neighborhoods: [
      ["Park Circle", "walkable heart with the big playground"],
      ["Olde North Charleston", "historic base era cottages"],
      ["Riverfront Park area", "along the old Navy yard"],
      ["Cameron Terrace", "quiet established streets"],
      ["Charleston Farms", "classic postwar homes"],
      ["Liberty Hill", "one of the oldest neighborhoods here"],
      ["Ashley Villa", "near Ashley Phosphate corridor"],
      ["Windsor", "off Dorchester Road"],
      ["Northwoods", "close to Northwoods Mall"],
      ["Deer Park", "family streets near Rivers Avenue"],
      ["Coosaw Creek", "gated golf community edge"],
      ["Indigo Fields", "newer subdivisions to the north"],
      ["Wando Woods", "wooded lots by the Ashley"],
      ["Pepperdam area", "near the airport and interstate"],
      ["Mixson", "revitalized blocks near Park Circle"],
      ["Oak Terrace Preserve", "green built homes in Park Circle"],
    ],
  },
  "mount-pleasant-sc": {
    intro: [
      "Mount Pleasant blends old fishing village charm with fast growing new neighborhoods stretching toward Highway 17. From Shem Creek to Carolina Park, folks here keep us busy hauling furniture, appliances and full cleanouts.",
      "We know the traffic, the tucked away subdivisions and the marsh front driveways. Whether you are downsizing in the Old Village or clearing a garage in Park West, Skedaddle makes your junk skedaddle.",
    ],
    neighborhoods: [
      ["Old Village", "historic homes near Shem Creek"],
      ["I'On", "walkable village with ponds"],
      ["Park West", "sprawling family community"],
      ["Carolina Park", "newer homes and the library"],
      ["Rivertowne", "golf and marsh views"],
      ["Dunes West", "gated community off Highway 41"],
      ["Snee Farm", "established golf course streets"],
      ["Belle Hall", "near Towne Centre shopping"],
      ["Hobcaw", "wooded lots along the creek"],
      ["Brickyard Plantation", "family friendly and gated"],
      ["Longpoint", "close to the Wando bridge"],
      ["Wakendaw", "quiet mature neighborhoods"],
      ["Hamlin Plantation", "amenity rich community"],
      ["Seaside Farms", "near Isle of Palms connector"],
      ["Ravens Run", "airpark and larger lots"],
      ["Charleston National", "golf community to the north"],
    ],
  },
  "west-ashley-sc": {
    intro: [
      "West Ashley spreads out along the Ashley River with a mix of mid century ranches, newer subdivisions and shady oak lined streets. It is one of the busiest corners of our service area for garage and home cleanouts.",
      "From Avondale to the far reaches of Bees Ferry Road, Skedaddle hauls away furniture, yard debris and whole house clutter. We know the shortcuts around Sam Rittenberg and Glenn McConnell, so we get there fast.",
    ],
    neighborhoods: [
      ["Avondale", "shops and bungalows near the bridge"],
      ["Byrnes Downs", "tidy postwar cottages"],
      ["South Windermere", "near the shopping center"],
      ["Carolina Bay", "newer homes off Glenn McConnell"],
      ["Grand Oaks Plantation", "family subdivisions"],
      ["Shadowmoss", "golf community off Highway 61"],
      ["Drayton on the Ashley", "riverside living"],
      ["Ashleyville", "historic settlement community"],
      ["Maryville", "one of the oldest areas here"],
      ["Parkshore", "quiet established streets"],
      ["Village Green", "central and convenient"],
      ["Ashborough", "near Bees Ferry Road"],
      ["Providence Commons", "newer builds"],
      ["Schieveling Plantation", "wooded and gated"],
      ["Church Creek", "family homes and ponds"],
      ["Sylvan Shores", "along the tidal creeks"],
    ],
  },
  "daniel-island-sc": {
    intro: [
      "Daniel Island feels like its own tidy town, with planned neighborhoods, waterfront parks and homes that get refreshed often. That steady flow of moves and remodels keeps Skedaddle hauling here.",
      "We clear out garages, haul old furniture and manage rental turnovers across the island, working neatly in these well kept communities. Quick, courteous and always upfront.",
    ],
    neighborhoods: [
      ["Daniel Island Park", "premier golf and river homes"],
      ["Codner's Ferry", "central village blocks"],
      ["Smythe Park", "around the lake and green"],
      ["Etiwan Park", "close to the ballfields"],
      ["Center Park", "near shops and dining"],
      ["River Landing", "waterfront condos"],
      ["Ithecaw Creek", "quiet marsh edge lots"],
      ["Beresford Creek", "along the creek views"],
      ["Pierce Park", "newer townhomes"],
      ["Cochran Park", "family streets"],
      ["Barfield Park", "central and walkable"],
      ["Scott Park", "near the schools"],
      ["Wando Landing", "riverfront community"],
      ["Governors Park", "established homes"],
      ["Island Park Drive", "the main loop"],
    ],
  },
  "park-circle-sc": {
    intro: [
      "Park Circle is the beating heart of North Charleston's revival, packed with restored cottages, a legendary playground and a walkable strip of restaurants on East Montague. All that renovating means lots of junk to clear.",
      "Skedaddle hauls remodel debris, old furniture and full cleanouts throughout Park Circle and the streets around it. We keep it friendly and fast so you can get back to enjoying the neighborhood.",
    ],
    neighborhoods: [
      ["East Montague", "the walkable dining strip"],
      ["Olde Village", "restored base era cottages"],
      ["Oak Terrace Preserve", "green built modern homes"],
      ["Mixson", "newer community with a pool"],
      ["Montague Terrace", "tidy classic blocks"],
      ["Hazelwood", "quiet family streets"],
      ["Fibreville", "historic mill era homes"],
      ["Accabee", "close to the riverfront"],
      ["The Commons", "near the sports complex"],
      ["Virginia Avenue", "leafy residential"],
      ["Buist Avenue", "central and convenient"],
      ["Jenkins Avenue", "near the playground"],
      ["Durant Avenue", "restored bungalows"],
      ["OConnor Street", "small lot cottages"],
      ["Spruill Avenue edge", "toward the old base"],
    ],
  },
  "summerville-sc": {
    intro: [
      "Summerville, the Flowertown in the Pines, is growing fast while holding onto its historic downtown and towering pines. Between the old cottages and the sprawling new subdivisions, there is always something to haul.",
      "Skedaddle covers Summerville and the neighborhoods pushing out toward Nexton and Cane Bay, clearing garages, hauling yard debris and handling whole home cleanouts. Fast service and honest pricing every time.",
    ],
    neighborhoods: [
      ["Historic Downtown", "azaleas and old cottages"],
      ["Legend Oaks Plantation", "golf community off Highway 61"],
      ["The Ponds", "amenity rich with a historic farmhouse"],
      ["White Gables", "walkable and established"],
      ["Newington Plantation", "mature family streets"],
      ["Bridges of Summerville", "central and convenient"],
      ["Wescott Plantation", "large golf community"],
      ["Ashborough", "near Bacons Bridge Road"],
      ["Corey Woods", "quiet older subdivision"],
      ["Weatherstone", "family friendly streets"],
      ["Tea Farm", "wooded lots"],
      ["Reminisce", "near Central Avenue"],
      ["Pine Forest", "golf and family homes"],
      ["Gahagan", "close to downtown"],
      ["McKewn", "newer builds off Highway 17A"],
      ["Kings Grant", "established with a country club"],
    ],
  },
  "goose-creek-sc": {
    intro: [
      "Goose Creek is a busy Berkeley County hub with tidy neighborhoods, plenty of families and a whole lot of garages that need clearing. Skedaddle is a regular sight hauling junk around town.",
      "From Crowfield to the streets near the Naval Weapons Station, we handle furniture removal, appliance pickup and full cleanouts. Quick to respond and always upfront on price.",
    ],
    neighborhoods: [
      ["Crowfield Plantation", "big golf community with lakes"],
      ["Montague Plantation", "family friendly streets"],
      ["Foxborough", "established neighborhood"],
      ["Brandymill", "central and convenient"],
      ["Hamlets", "quiet residential"],
      ["St James Estates", "larger lots"],
      ["Liberty Hall Plantation", "newer subdivision"],
      ["Sedgefield", "mature streets"],
      ["Pineview", "close to Red Bank Road"],
      ["Boulder Bluff", "family homes"],
      ["Devon Forest", "wooded and established"],
      ["The Retreat", "near Crowfield"],
      ["Greystone", "newer builds"],
      ["Sugar Creek", "quiet cul de sacs"],
      ["Beverly Hills", "older established area"],
    ],
  },
  "hanahan-sc": {
    intro: [
      "Hanahan packs a friendly small town feel right between North Charleston and Goose Creek, with Goose Creek Reservoir nearby and neighborhoods full of longtime residents. That means plenty of well loved homes ready for a good clear out.",
      "Skedaddle hauls furniture, appliances and full garage cleanouts across Hanahan, working fast and keeping it tidy. Give us a shout and we will make that junk skedaddle.",
    ],
    neighborhoods: [
      ["Tanner Plantation", "big community with shops"],
      ["Eagle Landing", "near the reservoir"],
      ["Berkeley Hills", "established family streets"],
      ["Yeamans Park", "close to the ballfields"],
      ["Foster Creek", "along the creek"],
      ["Bowen Village", "newer homes"],
      ["Dominion Hills", "quiet residential"],
      ["Sedgefield", "mature lots"],
      ["Windsor Hill edge", "toward Dorchester Road"],
      ["Otranto", "near the country club"],
      ["Hickory Hill", "older established area"],
      ["Kings Grant edge", "wooded streets"],
      ["Reservoir area", "waterfront adjacent"],
      ["Tanner Hall", "the town center hub"],
      ["Coosaw Preserve", "newer subdivision"],
    ],
  },
  "ladson-sc": {
    intro: [
      "Ladson sits right where Charleston, Berkeley and Dorchester counties meet, home to the Coliseum, the fairgrounds and a mix of established and growing neighborhoods. There is no shortage of junk to haul around here.",
      "Skedaddle clears garages, hauls yard debris and manages full cleanouts throughout Ladson. We are fast, friendly and always upfront on the price.",
    ],
    neighborhoods: [
      ["College Park", "near the college corridor"],
      ["Summerhaven", "family friendly streets"],
      ["McChune", "quiet established area"],
      ["Wescott edge", "toward the golf community"],
      ["Deertrack", "wooded lots"],
      ["Hunters Bend", "central and convenient"],
      ["Cypress Grove", "newer homes"],
      ["The Farm at Wescott", "amenity rich"],
      ["Ladson Village", "older established blocks"],
      ["Pinehill", "near Highway 78"],
      ["Whitehall", "family subdivision"],
      ["Coosaw Creek edge", "gated golf border"],
      ["Fairgrounds area", "near the Coliseum"],
      ["Gable Oaks", "quiet cul de sacs"],
      ["Cedar Grove", "newer builds"],
    ],
  },
  "moncks-corner-sc": {
    intro: [
      "Moncks Corner is Berkeley County's seat, sitting near Lake Moultrie and the old Santee Canal with a proud small town feel. From lakeside camps to in town cottages, folks here call us to haul it all.",
      "Skedaddle handles furniture removal, appliance pickup and full property cleanouts across Moncks Corner and the lake communities. Country roads are no problem for us.",
    ],
    neighborhoods: [
      ["Downtown Moncks Corner", "the historic Main Street area"],
      ["Fairlawn", "near the old plantation grounds"],
      ["Foxbank Plantation", "big community with a lake"],
      ["Spring Grove Plantation", "newer amenity rich homes"],
      ["Berkeley Country Club", "golf and mature streets"],
      ["Whitesville", "rural edges to the north"],
      ["Pinopolis", "historic lakeside village"],
      ["Cordesville", "wooded rural community"],
      ["Sangaree edge", "toward Highway 17A"],
      ["Strawberry", "along the Cooper River"],
      ["Cypress Gardens area", "near the swamp gardens"],
      ["Oakley", "quiet country lots"],
      ["Stony Landing", "near the canal park"],
      ["Lake Moultrie shore", "camps and cottages"],
      ["Carnes Crossroads edge", "newer development"],
    ],
  },
  "bonneau-sc": {
    intro: [
      "Bonneau is a small Berkeley County town near the shores of Lake Moultrie, where fishing camps, family homesteads and quiet country lots set the pace. When it is time to clear out a shed or a whole property, Skedaddle makes the trip.",
      "We haul furniture, appliances, yard debris and full cleanouts throughout Bonneau and the lake area. No job is too far off the beaten path for us.",
    ],
    neighborhoods: [
      ["Bonneau Village", "the small town center"],
      ["Bonneau Beach", "lakeside camps and cottages"],
      ["Lake Moultrie shore", "fishing spots and docks"],
      ["Old Highway 52 area", "country homesteads"],
      ["Russellville edge", "rural to the north"],
      ["Pineville area", "quiet farm lots"],
      ["Bonneau Ferry road", "wooded properties"],
      ["Santee shore", "near the water"],
      ["Cross edge", "toward the upper lake"],
      ["Macedonia", "small rural community"],
      ["Shulerville edge", "deep country"],
      ["Highway 6 corridor", "scattered homesteads"],
      ["Black Oak", "farm country"],
      ["Rembert C Dennis area", "near the wildlife land"],
      ["Bonneau town limits", "in town cottages"],
    ],
  },
  "cane-bay-sc": {
    intro: [
      "Cane Bay is one of the fastest growing planned communities in the Lowcountry, a sprawling stretch of new neighborhoods, lakes and schools off Highway 176. All those new homes mean lots of moving boxes, old furniture and remodel debris.",
      "Skedaddle keeps up with Cane Bay's growth, hauling away everything from single items to full garage cleanouts. Fast scheduling and friendly crews are our promise.",
    ],
    neighborhoods: [
      ["Cane Bay Plantation", "the sprawling main community"],
      ["Lindera Preserve", "family homes near the schools"],
      ["The Village", "walkable central section"],
      ["Sanctuary Cove", "amenity rich living"],
      ["Four Seasons", "active adult community"],
      ["Riverbend", "newer subdivision"],
      ["Del Webb", "gated 55 plus streets"],
      ["Coastal Preserve", "wooded newer homes"],
      ["The Lakes", "waterfront lots"],
      ["Woodlands", "quiet cul de sacs"],
      ["Harvest", "recent builds"],
      ["Overton", "family friendly section"],
      ["Marne", "near the parkway"],
      ["Endicott", "newer streets"],
      ["Cane Bay Boulevard corridor", "the community spine"],
    ],
  },
  "nexton-sc": {
    intro: [
      "Nexton is Summerville's modern master planned community, full of sleek new homes, trails and a buzzing town center. With so many fresh moves and builds, there is always packaging, old furniture and clutter to clear.",
      "Skedaddle hauls it all across Nexton, from single item pickups to full cleanouts, working neatly in these tidy new neighborhoods. Quick, courteous and upfront.",
    ],
    neighborhoods: [
      ["Brighton Park", "the established village"],
      ["Midtown", "near the town center"],
      ["North Creek", "newer family homes"],
      ["Del Webb Nexton", "active adult gated"],
      ["The Waters", "amenity rich section"],
      ["Brighton Park Village", "walkable blocks"],
      ["Ssummers Corner edge", "toward the neighboring community"],
      ["Nexton Square area", "shops and dining"],
      ["Founders Park", "central green space"],
      ["Sanctuary", "quiet streets"],
      ["Parkside", "newer builds"],
      ["Linden", "family friendly"],
      ["Grand Oaks edge", "wooded border"],
      ["Nexton Parkway corridor", "the community spine"],
      ["Interchange area", "near the interstate"],
    ],
  },
  "carnes-crossroads-sc": {
    intro: [
      "Carnes Crossroads is a growing Berkeley County community near Goose Creek and Summerville, built around a historic crossroads with new homes, parks and a farmers market feel. Fresh construction keeps the junk piling up.",
      "Skedaddle hauls remodel debris, old furniture and full cleanouts throughout Carnes Crossroads. We show up fast and keep the price honest.",
    ],
    neighborhoods: [
      ["The Village at Carnes", "the walkable core"],
      ["Del Webb Carnes", "active adult gated"],
      ["The Regatta", "near the ponds"],
      ["Waterside", "waterfront lots"],
      ["Founders Row", "central section"],
      ["Cobblestone", "family homes"],
      ["Marion", "newer streets"],
      ["Palmetto Hall edge", "toward Goose Creek"],
      ["Liberty Hall Road corridor", "the main artery"],
      ["Overton edge", "border with Cane Bay"],
      ["Roper St Francis area", "near the hospital"],
      ["The Lake District", "around the water"],
      ["Nexton edge", "toward the neighbor community"],
      ["Farmers Market area", "the gathering spot"],
      ["Highway 17A corridor", "scattered new builds"],
    ],
  },
};
export default A;
